var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("hr"),
      _vm._v(" "),
      _vm.loading
        ? _c("ring-loader")
        : _c(
            "div",
            { staticClass: "portlet-body form" },
            [
              _c("div", { staticClass: "row" }, [
                _vm.canEdit
                  ? _c(
                      "div",
                      { staticClass: "col-sm-3" },
                      [
                        _c("singleselect", {
                          staticClass: "planner-multiselect",
                          attrs: {
                            checked: _vm.chosenType,
                            options: _vm.availableTypes,
                            title: _vm.trans("menu_planner.entity.brand"),
                            label: "value",
                            name: "typesSelect"
                          },
                          model: {
                            value: _vm.chosenType,
                            callback: function($$v) {
                              _vm.chosenType = $$v
                            },
                            expression: "chosenType"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canEdit
                  ? _c("div", { staticClass: "col-sm-8" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          on: { click: _vm.addType }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus" }),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.trans("menu_planner_select.add_type")
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "btn-set pull-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success margin-right-10",
                      on: { click: _vm.showModal }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.trans("menu_planner_select.copy_from_day")
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    { staticClass: "btn btn-info", on: { click: _vm.back } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.trans("menu_planner_select.back_to_show")
                          ) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm._l(_vm.groupedExpressMeals, function(item, position) {
                return [
                  _c("menu-planner-select-type", {
                    key: position,
                    attrs: {
                      brand: _vm.brand,
                      date: _vm.date,
                      "express-variant-id": _vm.expressVariantId,
                      "planned-meals": item.meals,
                      "available-meals": _vm.meals,
                      name: item.selectTypeName,
                      "type-id": item.selectTypeId,
                      "can-edit": _vm.canEdit
                    },
                    on: { remove: _vm.removeType }
                  })
                ]
              })
            ],
            2
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "modalLabel",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h3", { attrs: { id: "modalLabel" } }, [
                    _vm._v(
                      _vm._s(_vm.trans("menu_planner_select.copying_title")) +
                        "\n            "
                    ),
                    _vm._m(0)
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { staticClass: "col-form-label" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.trans("menu_planner_select.choose_brand")
                            ) +
                            ":\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("singleselect", {
                        staticClass: "planner-multiselect",
                        attrs: {
                          "allow-empty": false,
                          checked: _vm.brand,
                          options: _vm.copyFromBrands,
                          title: _vm.trans("menu_planner.entity.brand"),
                          name: "brand"
                        },
                        model: {
                          value: _vm.fromBrand,
                          callback: function($$v) {
                            _vm.fromBrand = $$v
                          },
                          expression: "fromBrand"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { staticClass: "col-form-label" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.trans("menu_planner_select.choose_date")
                            ) +
                            ":\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("date-picker", {
                        attrs: { time: false, "init-value": false },
                        model: {
                          value: _vm.copyFromDate,
                          callback: function($$v) {
                            _vm.copyFromDate = $$v
                          },
                          expression: "copyFromDate"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "button", disabled: !_vm.copyFromDate },
                      on: { click: _vm.copyMenu }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.trans("menu_planner_select.copy")) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn default",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.trans("form.cancel")) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a88b8fec", { render: render, staticRenderFns: staticRenderFns })
  }
}